export default __webpack_public_path__ + "static/media/WizardTower_tmb.1ba56cb6.jpg";